// src/components/DatabaseExplorer/DatabaseSelector.jsx

import React from "react";
import { getCurrentDate } from "../Utilitie";

export default function DatabaseSelector({
  databases,
  database,
  table,
  tables,
  onDatabaseChange,
  onTableChange,
  onLoad,
  loading,
  date,
  setDate,
}) {
  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body p-3 p-md-4">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md ">
            <label className="form-label fw-semibold">Database</label>

            <select
              className="form-select"
              value={database}
              onChange={(event) => onDatabaseChange(event.target.value)}
            >
              {databases.map((name) => (
                <option key={name} value={name}>
                  {name?.replace(/_/g, " ")?.toUpperCase()}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md ">
            <label className="form-label fw-semibold">Table</label>

            <select
              className="form-select"
              value={table}
              onChange={(event) => {
                onTableChange(event.target.value);
              }}
              disabled={!tables.length}
            >
              {tables.map((table, i) => (
                <option key={i} value={table.table}>
                  {table.table?.replace(/_/g, " ")?.toUpperCase()}
                </option>
              ))}
            </select>
          </div>{" "}
          <div className="col-12 col-md ">
            <label className="form-label fw-semibold">From</label>
            <input
              type="date"
              className="form-control"
              max={date?.to}
              value={date.from}
              onChange={(e) => {
                setDate({ ...date, from: e.target.value });
              }}
            />{" "}
          </div>{" "}
          <div className="col-12 col-md ">
            <label className="form-label fw-semibold">to</label>

            <input
              type="date"
              className="form-control"
              max={getCurrentDate()}
              value={date.to}
              onChange={(e) => {
                setDate({ ...date, to: e.target.value });
              }}
            />
          </div>
          <div className="col-12 col-md-2">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={onLoad}
              disabled={loading || !database || !table}
            >
              {loading ? "Loading..." : "Load table"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
